export enum LastContactType {
  // event types
  Comment = "Comment",
  Email = "Email",
  MetInPerson = "MetInPerson",
  // PhoneCall = "PhoneCall",
  Registered = "Registered",
  SMS = "SMS",
  Reminder = "Reminder",
  Noanswer = "Noanswer",
  Interest = "Interest",
  Call = "Call",

  // compound types
  NoComment = "NoComment",
  NoCall = "NoCall",
  NoContactAttempts = "NoContactAttempts",
  NoCallAttempts = "NoCallAttempts",
}
